// extracted by mini-css-extract-plugin
export default {"cls1":"ISq6Lam0zGHW2J4du9Ho","cls2":"k2TmkZkf9Nvr1oLUm4tX ISq6Lam0zGHW2J4du9Ho","isTabletDown":"D0naeycwlQgbLqTbupkN","isPhone":"lZb0rcPOQ_Sq0jgfML86"};